import { UI, HStack, VStack } from '@genial/components';
import { BoxRadius, Color } from '@genial/design-tokens';
import { Box, Pressable } from 'native-base';
import React from 'react';

import { PublicOfferAssetToInvestNormalized } from '../../../../../../../../../../store/product/types';

export interface PublicOfferRulesProps {
  publicOfferAssetDetails?: PublicOfferAssetToInvestNormalized;
  publicOfferAssetDetailsLoading: boolean;
}

export const PublicOfferRules: React.FC<PublicOfferRulesProps> = ({
  publicOfferAssetDetails,
  publicOfferAssetDetailsLoading,
}) => {
  const [rulesOpen, setRulesOpen] = React.useState(false);

  const handleChangeRulesOpen = () => {
    if (publicOfferAssetDetailsLoading) {
      return;
    }
    setRulesOpen((state) => !state);
  };

  const hasRules = !!publicOfferAssetDetails?.rules;

  return (
    <Box bg={Color.background} px="inline.xxxs" borderRadius={BoxRadius.sm}>
      <Pressable w="full" py="stack.xxxs" onPress={handleChangeRulesOpen}>
        <HStack justifyContent="space-between" alignItems="center">
          <UI.Text
            variant="semibold"
            isLoading={publicOfferAssetDetailsLoading}
            maxW={publicOfferAssetDetailsLoading ? '1/3' : 'full'}>
            Regras da oferta
          </UI.Text>
          <UI.Icon name={rulesOpen ? 'ChevronUp' : 'ChevronDown'} size="xs" />
        </HStack>
      </Pressable>
      {!!rulesOpen && (
        <VStack space="stack.xxxs" pb="stack.xxxs">
          {!hasRules && (
            <UI.Text variant="regular" fontSize="xs" color="brand.tertiary.principal">
              Nenhuma regra disponível
            </UI.Text>
          )}
          {!!hasRules && <UI.Text fontSize="xs">{publicOfferAssetDetails.rules}</UI.Text>}
        </VStack>
      )}
    </Box>
  );
};
